const CardCRM = require("images/card-crm.png");
const CardLayout = require("images/card-pc.png");
const CardSettings = require("images/card-set.png");
const CardGraphs = require("images/card-graph.png");

export default {
  layout: {
    alt: "Ícone de computador",
    text: "Layout",
    img: CardLayout,
  },
  filters: {
    alt: "Ícone de rodas dentadas",
    text: "Filtros de busca",
    img: CardSettings,
  },
  graphics: {
    alt: "Ícone de quadro com gráfico",
    text: "Gráficos",
    img: CardGraphs,
  },
  crm: {
    alt: "Ícone de grupo de pessoas",
    text: "CRM",
    img: CardCRM,
  },
};
